import angular from 'angular';
/** Amount Field Group */
import { amountFieldGroupComponent } from './dom/amountFieldGroup';
/** Currency Input */
import { CurrencyInputDirective } from './dom/currencyInput';
/** Month Selector */
import { MonthSelectorDirective } from './dom/monthSelector';
/** Percent Input */
import { PercentInputDirective } from './dom/percentInput';

export default angular
  .module('csm.books.dom', [])
  .directive('currencyInput', CurrencyInputDirective)
  .directive('monthSelector', MonthSelectorDirective)
  .directive('percentInput', PercentInputDirective)
  .component('amountFieldGroup', amountFieldGroupComponent)
  .name;